import { CONTACT } from "@/data/site";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-asphalt">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12 pt-16 pb-28 sm:pb-16">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="grid place-items-center h-10 w-10 bg-jcb text-black font-khand font-700 text-xl">SS</span>
            <span className="font-khand font-600 text-2xl leading-none">
              SS GROUP
              <span className="block font-plex text-[9px] tracking-[0.25em] text-neutral-400">CONSTRUCTION · TRAVELS</span>
            </span>
          </div>
          <p className="mt-5 max-w-xs font-hind text-neutral-400 leading-relaxed">
            एक ही जगह से भरोसेमंद JCB निर्माण सेवाएँ और टैक्सी यात्रा — {CONTACT.areaEn}.
          </p>
        </div>

        <div>
          <p className="font-plex text-[10px] tracking-[0.25em] uppercase text-neutral-500">सेवाएँ / Services</p>
          <ul className="mt-5 space-y-2 font-hind text-neutral-300">
            <li>JCB खुदाई, लेवलिंग, सड़क कार्य</li>
            <li>प्लॉट सफाई व मलबा हटाना</li>
            <li>Maruti Ertiga (Taxi Permit)</li>
            <li>Tata Tigor — Local & Outstation</li>
            <li>एयरपोर्ट, रेलवे, शादी, टूर</li>
          </ul>
        </div>

        <div>
          <p className="font-plex text-[10px] tracking-[0.25em] uppercase text-neutral-500">संपर्क / Contact</p>
          <ul className="mt-5 space-y-2 font-hind text-neutral-300">
            <li>Call / WhatsApp: {CONTACT.phoneDisplay}</li>
            <li>{CONTACT.address}</li>
            <li>PIN: {CONTACT.pincode}</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-plex text-[10px] tracking-[0.2em] uppercase text-neutral-500">
          © {new Date().getFullYear()} SS Group India — All Rights Reserved
        </p>
        <p className="font-plex text-[10px] tracking-[0.2em] uppercase text-neutral-400">
          Made with grit in Rajasthan
        </p>
      </div>
    </div>
  </footer>
);
